import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store';

import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'

Vue.use(VueI18n);

const messages = {
    'en-US': Object.assign(require('./en.json'), enLocale),
    'ru-RU': Object.assign(require('./ru.json'), ruLocale)
};

// Create VueI18n instance with options
const index = new VueI18n({
    locale: store().getters.getLang, // set locale
    fallbackLocale: 'en-US',
    messages, // set locale messages
});

// index.n= function (nValue) {
//     return new Intl.NumberFormat(false, { maximumFractionDigits: 2}).format(nValue)
// }

ElementLocale.i18n((key, value) => index.t(key, value));

export default index